<template>
    <div class="anchor-center">
        <xi-top></xi-top>
        <div class="center-container">
            <div class="top-out-wrapper">
                <div class="top-bg-wrapper">
                    <div class="top-inner-wrapper">
                        <img :src="userObj.userPortrait100">
                        <div class="top-center-wrapper">
                            <span>{{userObj.nickname}}</span>
                            <div class="authorization">
                                <span class="margin-right: 5px;">{{ getLabel}}</span>
                                <i class="icon icon-vip" :class="vipIconClass"></i>
                            </div>

                            <div class="datas">
                                <router-link @click.native="getTodoCount();getAvailableAnnouncement();readAllMessage();"
                                             :to="{name:'anchorMessage'}" class="item">
                                    <span class="data">{{ unReadMessageCount }}</span>
                                    <span class="title">{{ $t('word.message') }}</span>
                                </router-link>
                                <!-- <div class="item" v-else>
                                    <span class="data">0</span>
                                    <span class="title">{{ $t('word.message') }}</span>
                                </div> -->
                                <router-link @click.native="getNewStatus();"
                                             :to="{name:'anchorTodo'}" class="item">
                                    <div class="data-wrapper">
                                        <span v-if="todos[1] > 0" class="data-alert">收到新的任务邀约</span>
                                        <span class="data">{{ todos[0] }}</span>
                                    </div>
                                    <span class="title">{{ $t('word.todo') }}</span>
                                </router-link>
                                <<!-- div class="item" v-else>
                                    <span class="data">0</span>
                                    <span class="title">{{ $t('word.todo') }}</span>
                                </div> -->
                                <router-link @click.native="getNewStatus();"
                                             :to="{name:'anchorAnnouncement'}" class="item">
                                    <span class="data">{{ unReadAnnouncement }}</span>
                                    <span class="title">{{ $t('word.announcement') }}</span>
                                </router-link>
                                <!-- <div class="item" v-else><span class="data">0</span><span class="title">{{ $t('word.announcement') }}</span></div> -->
                            </div>
                        </div>
                        <div class="top-tail-wrapper">
                            <a :href="`${$store.state.A_PC_HOST}/requirementview`"><span>{{ $t('comb.toFindTask') }}</span></a>
                            <button @click="toShowVacationDialog">{{ $t('word.vacate') }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-out-wrapper">
                <div class="content-inner-wrapper">
                    <div class="content-left">
                        <div class="center-works-category">
                            <router-link v-if="userObj.level >= 0" @click.native="getNewStatus" active-class="active" :to="{name: 'anchorAuditionTasks'}">
                                <div class="sticker"></div><i class="icon icon-20 icon-audition-participation va-mid mr10"></i><span>{{ $t('comb.myAudition') }}</span>
                            </router-link>
                            <a href="javascript:;" v-else>
                                <div class="sticker"></div><i class="icon icon-20 icon-audition-participation va-mid mr10"></i>
                                <span>{{ $t('comb.myAuditionTask') }}</span>
                            </a>
                            <router-link v-if="userObj.level >= 0" @click.native="getNewStatus" active-class="active" :to="{name: 'anchorMyAudioBook'}">
                                <div class="sticker"></div><i class="icon icon-20 icon-my-audio-book va-mid mr10"></i><span>{{ $t('comb.myTask') }}</span>
                            </router-link>
                            <a href="javascript:;" v-else>
                                <div class="sticker"></div><i class="icon icon-20 icon-my-audio-book va-mid mr10"></i>
                                <span>{{ $t('comb.myTask') }}</span>
                            </a>
                            <router-link v-if="userObj.level >= 0" @click.native="getNewStatus" active-class="active" :to="{name: 'anchorMyVoiceTag'}">
                                <div class="sticker"></div><i class="icon icon-20 icon-voice-tag va-mid mr10"></i><span>{{ $t('comb.myVoiceTag') }}</span>
                            </router-link>
                            <a href="javascript:;" v-else>
                                <div class="sticker"></div><i class="icon icon-20 icon-voice-tag va-mid mr10"></i>
                                <span>{{ $t('comb.myVoiceTag') }}</span>
                            </a>

                            <a href="http://www.ximalaya.com/center/tradeRecord" target="_blank">
                                <div class="sticker"></div>
                                <i class="icon icon-20 icon-earning-detail va-mid mr10"></i><span>{{ $t('comb.earningDetail') }}</span>
                            </a>
                            <a href="http://www.ximalaya.com/center/dataAnalyze/dataPreview" target="_blank">
                                <div class="sticker"></div>
                                <i class="icon icon-20 icon-data-analysis va-mid mr10"></i><span>{{ $t('comb.dataAnalysis') }}</span>
                            </a>
                            <a href="http://www.ximalaya.com/center/podcast" target="_blank">
                                <div class="sticker"></div>
                                <i class="icon icon-20 icon-broadcast va-mid mr10"></i><span>{{ $t('word.popularize') }}</span>
                            </a>
                        </div>
                    </div>
                    <div class="content-right">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
        <xi-footer></xi-footer>
        <el-dialog v-model="showLastAnnouncement" :close-on-click-modal="false" custom-class="announcement-pop" :show-close="false" top="30%">
            <div slot="title" style="text-align: center;">{{ $t('word.announcement') }}</div>
            <div slot="" class="announcement">
                <div class="title"><span v-if="lastAnnouncement">{{ lastAnnouncement.title }}</span></div>
                <p v-if="lastAnnouncement">{{ lastAnnouncement.content }}</p>
            </div>
            <div slot="footer" style="text-align: center;">
                <button class="pop-button" @click="closeAnnouncementPop">{{ $t('word.close') }}</button>
            </div>
        </el-dialog>
        <el-dialog v-model="showVacateDialog" :close-on-click-modal="false" custom-class="vacate-pop" :show-close="false" top="30%" size="tiny">
            <div slot="title" style="text-align: center;">{{ $t('word.vacate') }}</div>
            <div slot="" class="vacate">
                <div class="vacation-row"><span>请假人：</span><span>{{ $store.state.user.name }}</span></div>
                <div class="vacation-row">
                    <span>请假作品：</span>
                    <el-select v-model="vacations" multiple placeholder="请选择请假作品" :loading="isVacationLoading">
                        <el-option
                                size="small"
                                v-for="item in requirementList"
                                :label="item.name"
                                :value="item.requirementId">
                        </el-option>
                    </el-select>
                </div>
                <div class="vacation-row">
                    <span>请假时间：</span>
                    <el-date-picker
                            size="small"
                            v-model="vacationDate"
                            type="daterange"
                            placeholder="选择请假的日期范围">
                    </el-date-picker>
                </div>
                <div class="vacation-row">
                    <span>补充说明：</span>
                    <el-input
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="description">
                    </el-input>
                </div>
            </div>
            <div slot="footer" style="text-align: center;">
                <button class="pop-button" @click="setVacationApply">{{ $t('word.ok') }}</button>
                <button class="pop-button" @click="showVacateDialog=false">{{ $t('word.close') }}</button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import axios from 'axios';
    import dateformat from 'dateformat';
    import XiFooter from '../../components/Footer.vue';
    import XiTop from '../../components/Top.vue';
    export default {
        components: {
          axios,
          XiFooter,
          XiTop
        },
        data() {
            return {
              isVacationLoading: false,
              showVacateDialog: false,
              showLastAnnouncement: false,
              lastAnnouncement: {},
              unReadMessageCount: 0,
              todos: {},
              unReadAnnouncement: 0,
              pageLoading: true,
              requirementList: [],
              vacations: [],
              vacationDate: '',
              description: ''
            }
        },
        methods: {
          getVacatableRequirementList () {
            this.isVacationLoading = true;
            axios.get('/event/vacation/working/requirement').then(res => {
                this.requirementList = res.data.data;
              this.isVacationLoading = false;
            });
          },
          setVacationApply () {
            const that = this;
            const data = {
              requirementIds: this.vacations,
              startTimeStr: dateformat(this.vacationDate[0], 'yyyy-mm-dd'),
              endTimeStr: dateformat(this.vacationDate[1], 'yyyy-mm-dd'),
              description: this.description
            }
            axios.post('/event/vacation/apply', 'data='+JSON.stringify(data)).then(res => {
              if(res.data.code === 200) {
                that.showVacateDialog = false;
                that.vacations = [];
                that.vacationDate = '';
                that.description = '';
                that.$message({
                  type: 'success',
                  message: '请假申请提交成功'
                })
              } else {
                that.$message({
                  type: 'warning',
                  message: res.data.message
                })
              }
            });
          },
          toShowVacationDialog() {
            this.showVacateDialog = true;
            this.getVacatableRequirementList();
          },
          getUser(user) {
            let userState = this.$store.state;
            user.nickname = userState.user.name;
            user.isDubAnchor = userState.user.isDubAnchor;
            user.level = userState.user.anchor.level;
            let logoPic = userState.user.logoPic;
            const UPLOAD_IMG_HOST = userState.UPLOAD_IMG_HOST;
            const DEFAULT_PORTRAIT_100 = userState.DEFAULT_PORTRAIT_100;
            const DEFAULT_PORTRAIT_200 = userState.DEFAULT_PORTRAIT_200;

            const WEB_LARGE = '_web_large.';
            user.userPortrait200 = logoPic ? (/^([hH][tT]{2}[pP])/.test(logoPic) ? logoPic : `${UPLOAD_IMG_HOST}${logoPic.split('.')[0]}${WEB_LARGE}${logoPic.split('.')[1]}`) : `${DEFAULT_PORTRAIT_200}`;
            user.userPortrait100 = logoPic ? (/^([hH][tT]{2}[pP])/.test(logoPic) ? logoPic : `${UPLOAD_IMG_HOST}${logoPic.split('.')[0]}${WEB_LARGE}${logoPic.split('.')[1]}`) : `${DEFAULT_PORTRAIT_100}`;
          },
          getInit () {
            this.getNewStatus();
          },
          getNewStatus() {
            this.getUnreadMessage();
            this.getTodoCount();
            this.getAvailableAnnouncement();
          },
          getUnreadMessage () {
            axios.get('/api/message/unread/count').then(res => {
              this.unReadMessageCount = res.data.data;
            });
          },
          getTodoCount() {
            axios.get('/api/todo/anchor/count/map').then(res => {
              this.todos = res.data.data;
            });
          },
          getAvailableAnnouncement () {
            const that = this;
            axios.get('/api/notice/new?type=anchor').then(res => {
              that.pageLoading = false;
              that.unReadAnnouncement = res.data.data.unreadCount;
              if (res.data.data.lastNotice) {
                that.lastAnnouncement = res.data.data.lastNotice;
                that.showLastAnnouncement = true;
              }
            });
          },
          readAllMessage () {
            this.unReadMessageCount = 0;
          },
          closeAnnouncementPop () {
            this.showLastAnnouncement = false;
            axios.get(`/api/notice/detail/${this.lastAnnouncement.id}`).then(res => {

            });
          },
          setXMLog () {
            xmLog('pv.create', {
              item: "主播工作台"
            })
            xmLog("pv.send", "event", {
              serviceId: "aBookView",
              item: "主播工作台"
            })
          }
        },
        computed: {
          getLabel() {
            const user = this.$store.state.user;
            if (user.anchor.level >= 0) {
              return '认证主播'
            } else {
              // 未登录，未入驻
              return '未认证';
            }
          },
          vipIconClass () {
            let result = '';
            const anchor = this.$store.state.user.anchor;
            if(anchor.type === 1) {
              result = 'personal-vip-level-' + anchor.level + 'x2';
            } else {
              result = 'org-vip-level-' + anchor.level + 'x2';
            }
            return result;
          },
          userObj () {
            let userObj = {
              userPortrait200: '',
              userPortrait100: '',
              nickname: '',
              level: '',
              isDubAnchor: false

            };
            this.getUser(userObj);
            return userObj;
          }

        },
        beforeMount () {
          this.getInit();
          this.setXMLog();
        }
    }

</script>
<style lang="sass" scoped>
    @import "../../../sass/anchor/center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// CenterCommon.vue?d0f0101e